import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-8 order-2 order-xl-1" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Name </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" value=\"Kapor Center Investments\" readonly></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Phone No </label><input type=\"text\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"e.g. +001 321 4567\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Address </label><input type=\"passowrd\" class=\"form-control shadow-none rounded-0 text-black\" placeholder=\"your address here\"></div></div><div class=\"col-md-6\"><div class=\"form-group mb-15 mb-sm-20 mb-md-25\"><label class=\"d-block text-black fw-semibold mb-10\"> Country </label><select class=\"form-select shadow-none fw-semibold rounded-0\"><option selected>United States</option><option value=\"1\">Canada</option><option value=\"2\">Germany</option><option value=\"3\">Switzerland</option><option value=\"4\">Australia</option><option value=\"5\">Sweden</option></select></div></div>", 4)
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Investment Thesis ", -1)
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12\"><div class=\"d-flex align-items-center justify-content-between\"><button class=\"default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success\" type=\"submit\"> Save Changes </button><button type=\"button\" class=\"bg-transparent p-0 border-0 text-danger lh-1 fw-medium\"><i class=\"flaticon-delete lh-1 me-1 position-relative top-2\"></i><span class=\"position-relative\">Cancel</span></button></div></div>", 1)
const _hoisted_16 = { class: "col-xxl-4 order-1 order-xl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileLinks = _resolveComponent("ProfileLinks")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_ProfileContent = _resolveComponent("ProfileContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ProfileLinks)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_QuillEditor, {
                      theme: "snow",
                      placeholder: "Write your meta description",
                      toolbar: "full"
                    })
                  ])
                ])
              ]),
              _hoisted_15
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_ProfileContent)
    ])
  ]))
}